import type { PhysicalAddress } from 'src/graphql/generated';

// To check whether business address is verified from the database

// 1. If addressLine1 is not empty then we assume it is verified
// 2. The migration hirers have combined the address, suburb, and postcode values into only the addressLine1 field
//    -- So there will be no suburb and postcode values for those hirers
// Note: "country" is always presented as it is required during registration process

export const getIsBusinessAddressVerified = (
  postalAddress?: PhysicalAddress,
): boolean => Boolean(postalAddress?.addressLine1);
